import { axiosInstance } from "../../base/store/axios";

async function getAccountsReceivableForDate({
  date,
  creditorId,
  excludeInvoicesWithPeriodOutsideDate,
  skip = 0,
  take = 100,
}) {
  const data = await axiosInstance.post(
    `/accounting/gateways/account_receivables_v2/`,
    {
      CreditorPublicId: creditorId,
      Date: date,
      Skip: skip,
      Take: take,
      ExcludeInvoicesWithPeriodOutsideDate:
        excludeInvoicesWithPeriodOutsideDate || false,
      IsPeriodSpecific: false,
    }
  );

  return data;
}

export { getAccountsReceivableForDate };
